import { httpCreate } from './http';

const http = httpCreate('/shop/api/resell-customer');

export const resellCustomer = {
	list(params) {
		return http.post(`/list?pageSize=${params.pageSize}&pageNum=${params.pageNum}`, params);
	},
	activityList(params) {
		return http.post(`/${params.activityId}/list?pageSize=${params.pageSize}&pageNum=${params.pageNum}`, params);
	},
};
